export const partStates = {
  rejected: { id: <0>0, label: 'ELEMENT.PART_STATE.REJECTED', name: 'rejected' },
  approved: { id: <1>1, label: 'ELEMENT.PART_STATE.APPROVED', name: 'approved' },
  waiting: { id: <2>2, label: 'ELEMENT.PART_STATE.WAITING', name: 'waiting' },
  additional: { id: <3>3, label: 'ELEMENT.PART_STATE.ADDITIONAL', name: 'additional' }
}

export type PartState = typeof partStates[keyof typeof partStates];